import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useHistory } from 'react-router-dom';

const AdminGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = useAuth();
  const history = useHistory();

  const profile = auth.user?.profile as Record<string, unknown> | undefined;
  const rolesClaim = (profile?.role as unknown) ?? (profile as Record<string, unknown> | undefined)?.roles;
  const roles = Array.isArray(rolesClaim)
    ? rolesClaim
    : typeof rolesClaim === 'string'
      ? [rolesClaim]
      : [];
  const isAdmin = roles.includes('Admin');

  useEffect(() => {
    console.log('OIDC user profile:', auth.user?.profile);
  }, [auth.user]);

  useEffect(() => {
    if (!isAdmin) {
      history.replace('/dashboard');
    }
  }, [isAdmin, history]);

  if (!isAdmin) return null;

  return <>{children}</>;
};

export default AdminGuard;
